function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4906 20.2525V10.4333",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3725 22.0001H12.6158L13.2433 20.2527H17.745L18.3725 22.0001Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4905 10.4407C15.9499 10.4407 16.3223 10.0675 16.3223 9.60718C16.3223 9.14685 15.9499 8.77368 15.4905 8.77368C15.0311 8.77368 14.6588 9.14685 14.6588 9.60718C14.6588 10.0675 15.0311 10.4407 15.4905 10.4407Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1017 11.9177H10.8795",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.77818 16.2899C8.76169 16.5636 8.80125 16.8379 8.89444 17.0957C8.98763 17.3536 9.13248 17.5896 9.32007 17.7893C9.50766 17.989 9.73404 18.1481 9.98527 18.2569C10.2365 18.3656 10.5073 18.4217 10.781 18.4217C11.0546 18.4217 11.3254 18.3656 11.5766 18.2569C11.8279 18.1481 12.0543 17.989 12.2418 17.7893C12.4294 17.5896 12.5743 17.3536 12.6675 17.0957C12.7607 16.8379 12.8002 16.5636 12.7837 16.2899L10.8795 11.9031L8.77818 16.2899Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.77808 16.2898H12.7836",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9931 16.2899C17.9931 16.8232 18.2045 17.3346 18.5808 17.7116C18.957 18.0887 19.4674 18.3005 19.9995 18.3005C20.5317 18.3005 21.042 18.0887 21.4183 17.7116C21.7946 17.3346 22.0059 16.8232 22.0059 16.2899L20.0944 11.9031L17.9931 16.2899Z",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0003 16.2898H22.0059",
  stroke: "#434343",
  strokeLinejoin: "round"
});

var SvgScalesLeptop = function SvgScalesLeptop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScalesLeptop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scales-leptop.c3fa4c66.svg";
export { ForwardRef as ReactComponent };